module.exports = __webpack_public_path__ + "img/img_aboutus_enterprise_he@2x.18e0aa50.png";